import React from "react";
import { MantineProvider } from "@mantine/core";
import { HelmetProvider } from "react-helmet-async";
import { appTheme } from "./theme/theme";
import HomePage from "./components/HomePage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ContactPage from "./components/contact/ContactPage";
import PageShell from "./components/PageShell";
import ProductPage from "./components/product/ProductPage";
import SpecificProductPage from "./components/product/SpecificProductPage";
import product_info from "./constant/ProductInfo";
import Retail from "./components/product/product-categories/retail/retail";
import WholeSale from "./components/product/product-categories/wholesale/wholesale";
function App() {
  const route_map = product_info.map((product) => (
    <Route
      path={"/" + product.url_link}
      element={<SpecificProductPage product={product} />}
    />
  ));
  return (
    <HelmetProvider>
    <MantineProvider theme={appTheme} withGlobalStyles withNormalizeCSS>
      <Router>
        <PageShell>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/product" element={<ProductPage />} />
            <Route path="/specific-product" element={<SpecificProductPage />} />
            {route_map}
            <Route path="/retail" element={<Retail />} />
            <Route path="/wholesale" element={<WholeSale />} />
          </Routes>
        </PageShell>
      </Router>
    </MantineProvider>
    </HelmetProvider>
  );
}

export default App;
